const ACTION_MAP: Record<string, string> = {
    'criou proposta': 'Demanda criada',
    'editou proposta': 'Demanda editada',
    'editou': 'Demanda editada',
    'recusou proposta': 'Demanda recusada',
    'aceitou proposta': 'Demanda aceita',
    'cancelou proposta': 'Demanda cancelada',
    'criou rascunho': 'Rascunho criado',
    'cancelou': 'Demanda cancelada',
    'respondeu pendência de marjoracao': 'Pendência respondida',
    'respondeu pendência de reembolso': 'Pendência respondida',
    'respondeu pendência de adiantamento': 'Pendência respondida',
    'respondeu pendência de documentacao': 'Pendência respondida',
    'respondeu pendencia de correcao': 'Pendência respondida',
    'respondeu pendência de s_informacao': 'Pendência de solicitante respondida',
    'criou pendencia de marjoracao': 'Pendência criada',
    'criou pendencia de reembolso': 'Pendência criada',
    'criou pendencia de adiantamento': 'Pendência criada',
    'criou pendencia de correcao': 'Pendência criada',
    'criou pendencia de documentacao': 'Pendência criada',
    'criou pendencia de s_informacao': 'Pendência de solicitante criada',
    'Deu ciencia na orientaçao': 'Ciência de orientações completas',
    'aprovou proposta de solicitante': 'Proposta aprovada',
    'atribuiu profissional': 'Profissional atribuído',
    'alterou profissional': 'Profissional alterado',
    'atribuiu escritório solicitante': 'Solicitante atribuído',
    'alterou escritório solicitante': 'Solicitante alterado',
    'adicionou anexo': 'Anexo adicionado',
    'concluiu demanda': 'Conclusão do profissional',
    'interrompeu demanda': 'Demanda interrompida',
    'finalizou demanda com aceite': 'Demanda finalizada com aceite',
    'finalizou demanda com recusa': 'Demanda finalizada com recusa',
    'criou orientacao previa': 'Orientações prévias criadas',
    'editou orientacao previa': 'Orientações prévias alteradas',
    'criou orientacao completa': 'Orientações completas criadas',
    'editou orientacao completa': 'Orientações completas alteradas',
    'Duplicou': 'Demanda duplicada',
    // Prazo de aceite expirado não cancela a demanda; apenas remove o profissional
    'Excedeu': 'Prazo de aceite excedido',
    'iniciou triagem': 'Triagem iniciada',
    'triagem iniciada': 'Triagem iniciada',
    'encaminhou para contratação': 'Contratação de profissional iniciada',
    'encaminhou para contratacao': 'Contratação de profissional iniciada',
    'contratação de profissional iniciada': 'Contratação de profissional iniciada',
    'contratacao de profissional iniciada': 'Contratação de profissional iniciada',
    'triagem concluída': 'Contratação de profissional iniciada',
    'triagem concluida': 'Contratação de profissional iniciada',
    'iniciou demanda': 'Demanda iniciada',
    'demanda iniciada': 'Demanda iniciada',
    'retornou orientacao': 'Retornou orientação',
};

export function getActionText(acao: string): string {
    if (!acao) return '';

    const acaoLower = acao.toLowerCase();

    // Check for exact match first
    if (ACTION_MAP[acao]) {
        return ACTION_MAP[acao];
    }

    // Special case for "retornou orientacao" pattern
    if (acaoLower.startsWith('retornou orientacao')) {
        return 'Retornou orientação';
    }

    // Special case for "criou orientacao" followed by a number (ID)
    if (acaoLower.match(/^criou orientacao\s+\d+$/)) {
        return 'Orientações completas criadas';
    }

    // Sort entries by length to match longest patterns first
    const entries = Object.entries(ACTION_MAP).sort((a, b) => b[0].length - a[0].length);

    for (const [chave, valor] of entries) {
        if (acaoLower.includes(chave.toLowerCase())) {
            return valor;
        }
    }

    return acao;
}
